import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./AuthReducer";
import UserReducer from "./UserReducer";

const rootReducer = combineReducers({
  authReducer,
  UserReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
